export class Register {
    cnpj: string;
    cpf: string;
    name: string;
    email: string;
    birthDate: string;
    phone: string;
  
    constructor(registerData: any) {
      console.log(registerData)
      this.cnpj = (registerData.cnpj || '').replaceAll('.','').replaceAll('-','').replaceAll('/','');
      this.cpf = (registerData.cpf || '').replaceAll('.','').replaceAll('-','').replaceAll('/','');
      this.name = registerData.name;
      this.email = registerData.email;
      this.birthDate = this.birthDate = registerData.birthDate ? new Date(this.parseDateBrToISO(registerData.birthDate)).toISOString() : '';
      this.phone = (registerData.phone || '').replaceAll('.','').replaceAll('-','').replaceAll('/','');
    }

    parseDateBrToISO(date: string): string {
      if (!date || date.length !== 8) return '';

      const day = date.slice(0, 2);
      const month = date.slice(2, 4);
      const year = date.slice(4, 8);

      return `${year}-${month}-${day}`;
    }
  }
  